import type { BottleType } from "../schema";
import { INK, doc, imageSlot, labelWidth, text } from "./kit";
import type { LabelTemplate } from "./types";

// Corner mark: a small logo tucked into the top-left corner and the name set
// big and condensed. The design hugs the label's corners and edges, so each
// bottle gets its own layout (a re-bottled copy would drift off the corner).
export const logoCornerEditorial: LabelTemplate = {
  key: "logo-corner-editorial",
  name: "Corner mark",
  occasion: "modern",
  style: "Small logo, big type",
  description: "A small logo in the corner and your name, big and condensed.",
  hasImageSlot: true,
  slot: "logo",
  build(bottle: BottleType) {
    const W = labelWidth(bottle);
    const col = { x: 6, width: W - 12 };
    return doc(bottle, INK["warm-white"], [
      imageSlot({ x: 6, y: 6, width: 22, height: 14 }, "Your logo"),
      text({ ...col, text: "YOUR\nNAME", font: "bebas-neue", size: 15, color: INK.charcoal, baseline: 50, align: "left", lineHeight: 0.9 }),
      // The year's box spans the column (right-aligned); the line beside it is
      // drawn later, so both stay selectable where their words sit.
      text({ ...col, text: "2026", font: "montserrat", size: 2, color: INK.charcoal, baseline: 92, align: "right", tracking: 0.25 }),
      text({ x: 6, width: 60, text: "Cellar-bottled for the occasion", font: "montserrat", size: 1.6, color: INK.charcoal, baseline: 92, align: "left", tracking: 0.15 }),
    ]);
  },
};
